import mod from "-!./LoginBlock.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./LoginBlock.js?vue&type=script&lang=js&external"